
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
.slh-nav-item {
  font-family: var(--slh-default-font-family, "Open Sans");
  font-style: normal;
  font-weight: var(--slh-base-bold-font-weight, 700);
  font-size: var(--slh-base-xs-font-size, 14px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-neutral-shade-60, #62779F);
  padding: 8px;
  height: 48px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  position: relative;
  text-transform: none;
  margin-left: -4px;
  margin-right: -4px;
  text-decoration: none;
}
.slh-nav-item:hover {
  color: var(--slh-color-neutral, #39455D);
  background-color: var(--slh-color-neutral-shade-10, #F6F7FA);
}
.slh-nav-item.active.prominent {
  position: relative;
}
.slh-nav-item.active.prominent::before {
  content: "";
  width: 4px;
  height: 24px;
  background-color: var(--slh-color-primary, #3B87D4);
  border-radius: 4px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.slh-nav-item.prominent.has-icon slot[name=icon] {
  margin-left: 4px;
}
.slh-nav-item:focus, .slh-nav-item.active:not(.organization-item) {
  color: var(--slh-color-neutral, #39455D);
  outline: none;
  background-color: var(--slh-color-neutral-shade-10, #F6F7FA);
}
.slh-nav-item slot {
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
.slh-nav-item slot[name=icon] {
  width: auto;
}
.slh-nav-item slot::slotted(*) {
  white-space: nowrap;
}
.slh-nav-item.has-icon slot[name=icon] {
  display: flex;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
}
.slh-nav-item.has-icon.organization-item slot[name=icon] {
  margin-left: 0;
}
.slh-nav-item.loading {
  position: relative;
  overflow: hidden;
  cursor: not-allowed;
  background-color: var(--slh-color-neutral-shade-20, #EBEEF4) !important;
}
.slh-nav-item.loading::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 2s infinite;
  content: "";
}
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
.slh-nav-item.loading slot {
  visibility: hidden;
}

@media (max-width: 560px) {
  .slh-nav-item.collapsed {
    display: none;
  }
}
:host(:focus-visible) {
  position: relative;
  outline: none;
  display: flex;
}
:host(:focus-visible):after {
  content: "";
  display: block;
  width: 100%;
  height: calc(100% - 4px);
  position: absolute;
  top: 0;
  left: 0;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 4px;
}
:host(:focus-visible) .slh-nav-item {
  width: 100%;
  background-color: var(--slh-color-neutral-shade-10, #F6F7FA);
}
`;
